/**
 * https://github.com/tldraw/tldraw/blob/d683cc09432197e89bddacf2b706b5eaad40e399/packages/tlschema/src/store-migrations.ts
 *
 * Changes:
 *  - Removed the _ in maps
 *  - Changed to SWRecord
 */ import { defineMigrations } from "@supersig/store";
const Versions = {
    RemoveCodeAndIconShapeTypes: 1,
    AddInstancePresenceType: 2,
    RemoveTLUserAndPresenceAndAddPointer: 3,
    RemoveUserDocument: 4
};
export { Versions as storeVersions };
/** @public */ export const storeMigrations = defineMigrations({
    // currentVersion: Versions.RemoveShapes,
    currentVersion: Versions.RemoveUserDocument,
    migrators: {
        [Versions.RemoveCodeAndIconShapeTypes]: {
            up: (store)=>{
                return Object.fromEntries(Object.entries(store));
            },
            down: (store)=>{
                // noop
                return store;
            }
        },
        [Versions.AddInstancePresenceType]: {
            up: (store)=>{
                return store;
            },
            down: (store)=>{
                return Object.fromEntries(Object.entries(store).filter(([, v])=>v.typeName !== "instance_presence"));
            }
        },
        [Versions.RemoveTLUserAndPresenceAndAddPointer]: {
            up: (store)=>{
                return Object.fromEntries(Object.entries(store).filter(([, v])=>!v.typeName.match(/^(user|user_presence)$/)));
            },
            down: (store)=>{
                return Object.fromEntries(Object.entries(store).filter(([, v])=>v.typeName !== "pointer"));
            }
        },
        [Versions.RemoveUserDocument]: {
            up: (store)=>{
                return Object.fromEntries(Object.entries(store).filter(([, v])=>!v.typeName.match("user_document")));
            },
            down: (store)=>{
                return store;
            }
        }
    }
});
